import { HttpStatusCodes } from '../utils';
import {
  NewsletterSubscribeRequestDto,
  NewsletterUnsubscribeRequestDto,
} from './interfaces/newsletter-request.interface';
import { NewsletterApiResponse } from './interfaces/newsletter-subscribe-api-response.interface';

export const newsletterApi = async (
  payload: NewsletterSubscribeRequestDto | NewsletterUnsubscribeRequestDto,
  integrationId: string,
): Promise<NewsletterApiResponse> => {
  const response = await fetch('/api/newsletter', {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      integrationId,
    }),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  });

  const data = await response.json();

  if (response.ok || response.status === HttpStatusCodes.CONFLICT) {
    return data;
  } else {
    throw Error(data.errorMessage || `Server error ${response.status}`);
  }
};
